import { render, staticRenderFns } from "./ProjectNotice.vue?vue&type=template&id=3fa1a344&scoped=true&"
import script from "./ProjectNotice.vue?vue&type=script&lang=js&"
export * from "./ProjectNotice.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNotice.vue?vue&type=style&index=0&id=3fa1a344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa1a344",
  null
  
)

export default component.exports